//@flow

import React from "react";
import moment from "moment";
import config from "@config";

export default function date(dateString: string, format: string = config.dateTimeFormat) {
  if (isNaN(Date.parse(dateString))) return "N/A";
  return <div className="ellipsis">{dateString ? moment(dateString).format(format) : ""}</div>;
}
